(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[104],{

/***/ 2540:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Pictures/[id]",
      function () {
        return __webpack_require__(8602);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Picture; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4246);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var components_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7596);
/* harmony import */ var utils_constant__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4807);
/* harmony import */ var services_PicturesAPI__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5110);














var Picture = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(Picture, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(Picture);
    function Picture(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(this, Picture);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            image: null
        };
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(Picture, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props, id = _props.id, image = _props.image;
                if (id) {
                    var _this = this;
                    (0,services_PicturesAPI__WEBPACK_IMPORTED_MODULE_8__/* .detailPictures */ .BF)(id).then(function(response) {
                        _this.setState({
                            image: response.data
                        });
                    });
                } else {
                    this.setState({
                        image: image
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var standalone = this.props.standalone;
                var image = this.state.image;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: standalone ? "picture-container" : "",
                    children: [
                        standalone && image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                                    children: image.pic_title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                    rel: "icon",
                                    href: "/logo.png"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                    charSet: "UTF-8"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                    name: "description",
                                    content: "Conquera99 Photoworld, welcome to my website, enjoy all the images, I hope it can give you a stories that can be remembered forever."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                    name: "keywords",
                                    content: "Conquera99, photography, portfolio, gallery, benny, conquera99 photoworld"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                    name: "author",
                                    content: "Benny"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                    name: "viewport",
                                    content: "width=device-width, initial-scale=1.0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "picture-hover",
                            style: {
                                width: standalone ? 500 : "100%",
                                height: "auto",
                                margin: "0 auto"
                            },
                            children: [
                                image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_5__.LazyLoadImage, {
                                    style: {
                                        width: "100%"
                                    },
                                    delayTime: 0,
                                    threshold: 100,
                                    alt: image.pic_title,
                                    crossOrigin: "anonymous",
                                    effect: "blur",
                                    className: "img-card",
                                    placeholderSrc: "".concat(utils_constant__WEBPACK_IMPORTED_MODULE_7__/* .baseURL */ .v).concat(image.pic_image, "-thumb.jpeg"),
                                    src: "".concat(utils_constant__WEBPACK_IMPORTED_MODULE_7__/* .baseURL */ .v).concat(image.pic_image, "-comp.jpeg")
                                }, image.pic_id),
                                standalone && image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "picture-captions",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "pic-action",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                onClick: function() {
                                                    return next_router__WEBPACK_IMPORTED_MODULE_2___default().back();
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_icons__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                    style: {
                                                        fontSize: 40
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "pic-captions-content",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    children: image.pic_title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                    children: image.pic_category_name
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                    children: image.pic_desc
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h6", {
                                                    children: [
                                                        "Upload At:\xa0",
                                                        moment__WEBPACK_IMPORTED_MODULE_3___default()(image.pic_create_date).format("DD MMM YYYY HH:mm:ss")
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return Picture;
}(react__WEBPACK_IMPORTED_MODULE_4__.Component);



/***/ }),

/***/ 8602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Picture__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(472);



var PicturePage = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return router.query.id ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Picture__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        id: router.query.id,
        standalone: true
    }) : null;
};
/* harmony default export */ __webpack_exports__["default"] = (PicturePage);


/***/ }),

/***/ 5836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ APIRequest; },
/* harmony export */   "_z": function() { return /* binding */ authenticateAPI; },
/* harmony export */   "vA": function() { return /* binding */ tokenName; }
/* harmony export */ });
/* unused harmony export validateTokenAPI */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4924);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3448);
/* harmony import */ var react_cookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1768);
/* harmony import */ var _utils_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);




var tokenHeaderName = "x-token";
var languageHeaderName = "x-language";
var AuthEndPoint = "Auth/";
var authenticateAPI = "".concat(AuthEndPoint, "authenticate");
var validateTokenAPI = "".concat(AuthEndPoint, "validateToken");
var tokenName = "token";
/**
 * API Request
 *
 * @param URL stringURL *required
 * @param formData FormData *optional
 * @param mode string *optional
 * @returns {Promise<T>}
 * @constructor
 */ function APIRequest(URL) {
    var formData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, mode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "POST";
    var token = react_cookies__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP && react_cookies__WEBPACK_IMPORTED_MODULE_0__/* ["default"].load */ .ZP.load(tokenName);
    var language = "en";
    return new Promise(function(resolve) {
        var _obj;
        fetch(_utils_constant__WEBPACK_IMPORTED_MODULE_1__/* .baseURL */ .v + URL, {
            method: mode,
            headers: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, tokenHeaderName, token), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, languageHeaderName, language), _obj),
            body: formData
        }).then(function(response) {
            return response.json();
        }).then(function(responseJSON) {
            if (responseJSON.error_code === 0) {
                resolve(responseJSON);
            } else {
                antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .Z.error({
                    message: "Error",
                    description: responseJSON.error_message
                });
            }
        }).catch(function(error) {
            antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .Z.error({
                message: "Error",
                description: error.message
            });
        });
    });
};


/***/ }),

/***/ 5110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$9": function() { return /* binding */ activePicturesByCategory; },
/* harmony export */   "BF": function() { return /* binding */ detailPictures; },
/* harmony export */   "L0": function() { return /* binding */ listPictures; },
/* harmony export */   "W8": function() { return /* binding */ savePictures; },
/* harmony export */   "r0": function() { return /* binding */ removePictures; }
/* harmony export */ });
/* unused harmony export activePictures */
/* harmony import */ var _BaseAPI__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5836);

function listPictures(searchKeyword, page, limit) {
    var formData = new FormData();
    formData.append("keyword", searchKeyword);
    formData.append("page", page);
    formData.append("limit", limit);
    return (0,_BaseAPI__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("Pictures/list", formData);
}
function savePictures(data) {
    var formData = new FormData();
    formData.append("pic_title", data.pic_title);
    formData.append("pic_title_old", data.id);
    formData.append("pic_category_name", data.pic_category_name);
    formData.append("pic_image", data.pic_image);
    formData.append("pic_desc", data.pic_desc);
    formData.append("pic_status", data.pic_status ? 1 : 0);
    return (0,_BaseAPI__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("Pictures/save", formData);
}
function removePictures(picID) {
    var formData = new FormData();
    formData.append("pic_id", picID);
    return (0,_BaseAPI__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("Pictures/remove", formData);
}
function activePictures() {
    return baseAPI("Pictures/activeList", null);
}
function activePicturesByCategory(categoryName) {
    var formData = new FormData();
    if (categoryName !== "All") {
        formData.append("pic_category_name", categoryName);
    }
    return (0,_BaseAPI__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("Pictures/loadByCategory", formData);
}
function detailPictures(picID) {
    var formData = new FormData();
    formData.append("pic_id", picID);
    return (0,_BaseAPI__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("Pictures/detail", formData);
}


/***/ }),

/***/ 4807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ baseURL; }
/* harmony export */ });
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1752);

var publicRuntimeConfig = (0,next_config__WEBPACK_IMPORTED_MODULE_0__["default"])().publicRuntimeConfig;
var baseURL = publicRuntimeConfig.apiUrl || "http://localhost/portfolio-admin/";


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [885,982,107,488,890,774,888,179], function() { return __webpack_exec__(2540); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);